<template>
	<v-dialog v-model="isVisible" persistent max-width="400" class="evaluation-name ">
		<p-card class="tw-p-6" style="overflow: hidden">
			<div
				style="background-color: #F9F9F9; margin: -21px -20px 20px;"
				class="evaluation-name-header tw-flex tw-justify-between tw-items-center tw-mb-8 tw-p-6"
			>
				<span class="tw-text-app-color-secondary text-lg">Nombre de evaluación</span>
				<close-icon @click="closeDialog()" class="cursor-pointer"></close-icon>
			</div>
			<v-text-field
				label="Nombre"
				solo
				hide-details
				class="input-text"
				v-model="evaluationName"
			></v-text-field>
			<p-horizontal-divider />
			<div class="tw-text-center">
				<p-button type="black" @click="onCancel">
					Cancelar
				</p-button>
				<p-button :disabled="!trim(evaluationName)" type="secondary" @click="onConfirm">
					Guardar
				</p-button>
			</div>
		</p-card>
	</v-dialog>
</template>
<script>
import { trim } from 'ramda';
import PCard from '../shared/components/ui/Card/p-card';
import PHorizontalDivider from '../shared/components/ui/p-horizontal-divider';
import CloseIcon from '../shared/components/icons/close-icon';
import PButton from '../shared/components/ui/p-button';

export default {
	name: 'three-sixty-evaluation-name-dialog',
	components: { PButton, CloseIcon, PHorizontalDivider, PCard },
	data() {
		return {
			isVisible: false,
			evaluationName: '',
		};
	},
	methods: {
		trim,
		openDialog() {
			this.isVisible = true;
		},
		onConfirm() {
			this.$emit('onConfirmClick', this.evaluationName);
			this.closeDialog();
		},
		onCancel() {
			this.$emit('onCancelClick', this.evaluationName);
			this.closeDialog();
		},
		closeDialog() {
			this.isVisible = false;
		},
		reset() {
			this.evaluationName = '';
		},
	},
};
</script>

<style lang="scss">
.evaluation-name {
	.evaluation-name-header {
		background-color: #f9f9f9;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/three-sixty-evaluation-name-dialog.vue